export default
{
    'Trang chủ': 'Hot',
    'Phim Bộ': 'Phim Bộ',
    'Phim Lẻ': 'Phim Lẻ',
    'Quốc gia': 'Quốc gia',
    'Sắp chiếu': 'Sắp chiếu',
    'Ngôn ngữ': 'Ngôn ngữ',
    'Tài khoản': 'Tài khoản',
    'Hành động': 'Hành động',
    'Cổ trang': 'Cổ trang',
    'Chiến tranh': 'Chiến tranh',
    'Tình cảm': 'Tình cảm',
    'Hài hước': 'Hài hước',
    'Âm nhạc': 'Âm nhạc',
    'Học đường': 'Học đường',
    'Trung Quốc': 'Trung Quốc',
    'Hàn Quốc': 'Hàn Quốc',
    'Nhật Bản': 'Nhật Bản',
    'Thái Lan': 'Thái Lan',
    'Ấn Độ': 'Ấn Độ',
    'Anh': 'Anh',
    'Hoạt hình': 'Hoạt hình',
    'PHIM ĐỀ CỬ': 'PHIM ĐỀ CỬ',
    'PHIM THỊNH HÀNH': 'PHIM THỊNH HÀNH',
    'PHIM BỘ': 'PHIM BỘ',
    'PHIM LẺ': 'PHIM LẺ',
    'PHIM HÀN QUỐC': 'PHIM HÀN QUỐC',
    'PHIM TRUNG QUỐC': 'PHIM TRUNG QUỐC',
    'Diễn viên:': 'Diễn viên:',
    'Đạo diễn:': 'Đạo diễn:',
    'Thể loại': 'Thể loại',
    'Đánh giá:': 'Đánh giá:',
    'Đề xuất cho bạn!': 'Đề xuất cho bạn!',
    'Kết quả tìm kiếm cho': 'Kết quả tìm kiếm cho',
    'Xem': 'Xem',
    'Chia sẻ': 'Chia sẻ',
    'Bình luận': 'Bình luận',
    'Viết bình luận...': 'WViết bình luận...',
    'Gửi': 'Gửi',
    'Xem tất cả': 'Xem tất cả',
    'Năm': 'Năm',
    'Đánh giá': 'Đánh giá',
  'Thời lượng': 'Thời lượng',
  'Không có mô tả.': 'Không có mô tả.',
  'Xem ngay': 'Xem ngay',
  'Báo lỗi': 'Báo lỗi',
  'Xem sau': 'Yêu thích',
  'Tập ': 'Tập ',
  'Diễn viên': 'Diễn viên',
  'Đạo diễn': 'Đạo diễn',
  'Thêm bình luận...': 'Thêm bình luận...',
  'Bình luận không được để trống': 'Bình luận không được để trống',
  'Phản hồi': 'Phản hồi',
  'Gợi ý cho bạn': 'Gợi ý cho bạn',
  'Top phim': 'Top phim',
  'Phim được đề xuất': 'Phim được đề xuất',
  'Dữ liệu đã được gửi tới Admin để xử lý': 'Dữ liệu đã được gửi tới Admin để xử lý',
  'Đã sao chép liên kết!': 'Đã sao chép liên kết!',
  'Không tìm thấy phim nào với từ khóa': 'Không tìm thấy phim nào với từ khóa',
  'Về trang chủ': 'Về trang chủ',
  'Miêu tả': 'Miêu tả',
  'Kết quả tìm kiếm: ': 'Kết quả tìm kiếm: ',
  'Đăng ký tài khoản': 'Đăng ký tài khoản',
  'Điền thông tin bên dưới để tạo tài khoản': 'Điền thông tin bên dưới để tạo tài khoản',
  'Tên hiển thị': 'Tên hiển thị',
  'Mật khẩu': 'Mật khẩu',
  'Xác nhận mật khẩu': 'Xác nhận mật khẩu',
  'Mật khẩu không khớp': 'Mật khẩu không khớp',
  'Tôi đồng ý với Điều khoản & Chính sách': 'Tôi đồng ý với Điều khoản & Chính sách',
  'Đăng ký': 'Đăng ký',
  'Đăng nhập': 'Đăng nhập',
  'Email không được để trống': 'Email không được để trống',
  'Email không hợp lệ': 'Email không hợp lệ',
  'Đăng ký thành công! Bạn sẽ được chuyển đến trang đăng nhập.': 'Đăng ký thành công! Bạn sẽ được chuyển đến trang đăng nhập.',
  'Chào mừng bạn quay lại! Vui lòng đăng nhập.': 'Chào mừng bạn quay lại! Vui lòng đăng nhập.',
  'Nhập email': 'Nhập email',
  'Nhập mật khẩu': 'Nhập mật khẩu',
  'Quên mật khẩu?': 'Quên mật khẩu?',
  'Chưa có tài khoản?': 'Chưa có tài khoản?',
  'Vui lòng nhập đầy đủ email và mật khẩu': 'Vui lòng nhập đầy đủ email và mật khẩu',
  'Đăng nhập thành công': 'Đăng nhập thành công',
  'Đăng nhập thất bại': 'Đăng nhập thất bại',
  'Có lỗi xảy ra': 'Có lỗi xảy ra',
  'Tên phim': 'Tên phim ...',
  'Không tìm thấy kết quả': 'Không tìm thấy kết quả',
  'Đăng xuất': 'Đăng xuất',
  'Đổi giao diện': 'Đổi giao diện',
  'Trang xem phim Online với giao diện hiện đại, thân thiện người dùng.': 'Trang xem phim Online với giao diện hiện đại, thân thiện người dùng.',
  'Nguồn phim tổng hợp từ các website lớn với đa dạng thể loại và quốc gia.': 'Nguồn phim tổng hợp từ các website lớn với đa dạng thể loại và quốc gia.',
  'Giới thiệu': 'Giới thiệu',
  'Liên hệ': 'Liên hệ',
  'Chính sách quyền riêng tư': 'Chính sách quyền riêng tư',
  'Khiếu nại bản quyền': 'Khiếu nại bản quyền',
  'Phim mới': 'Phim mới',
  'Phim hay': 'Phim hay',
  'Phim mới chill': 'Phim mới chill',
  'Phim 18': 'Phim 18',
  'Truyện tranh 18': 'Truyện tranh 18',
  'Nettruyen': 'Nettruyen',
  'Nettruyen ngôn tình': 'Nettruyen ngôn tình',
  'Hiện đại': 'Hiện đại',
  'Chính kịch': 'Chính kịch',
  'Cổ Trang': 'Cổ Trang',
  'Tình Cảm': 'Tình Cảm',
  'Hành Động': 'Hành Động',
  'Âu Mỹ': 'Âu Mỹ',
  'Việt Nam': 'Việt Nam',
  'TV Show': 'TV Show',

  'Danh sách phim của bạn': 'Danh sách phim yêu thích',
  'Bạn không có dữ liệu nào được lưu':'Bạn không có dữ liệu nào được lưu',
  'Bạn muốn xem gì?': 'Bạn muốn xem gì?',
  'Danh sách phim của bạn!': 'Danh sách phim yêu thích!',
  'Hết thời gian yêu cầu, vui lòng kiểm tra lại đường truyền internet': 'Hết thời gian yêu cầu, vui lòng kiểm tra lại đường truyền internet',
  '⏳ Hết thời gian chờ. Vui lòng thử lại!': '⏳ Hết thời gian chờ. Vui lòng thử lại!',
  'Lọc':'Lọc',
  'Danh sách phim:': 'Danh sách phim:',
  "Không có dữ liệu được hiển thị, vui lòng tải lại trang": "Không có dữ liệu được hiển thị, vui lòng tải lại trang",
  "Hết thời gian chờ, vui lòng tải lại trang": "Hết thời gian chờ, vui lòng tải lại trang",
  "Thời gian chiếu": "Thời gian chiếu",
  "Đã lưu": "Phim đã lưu",
  'Bạn không có phim nào đã được lưu': 'Bạn không có phim nào đã được lưu',
'Lịch chiếu':'Lịch chiếu',

"BXH HTTQ THỊNH HÀNH": "BXH HTTQ THỊNH HÀNH",
"Mãn Nhãn với Phim Chiếu Rạp":"Mãn Nhãn với Phim Chiếu Rạp",
  "PHIM VIỆT NAM": "PHIM VIỆT NAM",
  "PHIM MỚI": "PHIM MỚI",
  "PHIM TÌNH CẢM": "PHIM TÌNH CẢM",
  "Vừa xong": "Vừa xong",
  "phút trước": "phút trước",
  "giờ trước": "giờ trước",
  "ngày trước": "ngày trước",
  "Xem từ đầu": "Xem từ đầu",
  "Giới thiệu:": "Giới thiệu:",
  "Thể loại:": "Thể loại:",
  "Quốc gia:": "Quốc gia:",
  "Đang cập nhật": "Đang cập nhật",
  "Số tập:": "Số tập:",
  "tập": "tập",
  "Thời lượng:": "Thời lượng:",
  "Tập phim": "Tập phim",
  "Đề xuất": "Đề xuất",
  "Xem thêm": "Xem thêm",
  "Thu gọn": "Thu gọn",
  "Chưa có bình luận nào. Hãy là người đầu tiên!": "Chưa có bình luận nào. Hãy là người đầu tiên!",
  "Chưa có dữ liệu của phim này": "Chưa có dữ liệu của phim này",
  "Vui lòng theo dõi lại sau": "Vui lòng theo dõi lại sau",
  "Chủ Nhật": "Chủ Nhật",
  "Thứ Hai": "Thứ Hai",
  "Thứ Ba": "Thứ Ba",
  "Thứ Tư": "Thứ Tư",
  "Thứ Năm": "Thứ Năm",
  "Thứ Sáu": "Thứ Sáu",
  "Thứ Bảy": "Thứ Bảy",
  "Trailer sẽ được phát trước": "Trailer sẽ được phát trước",
  "Bỏ qua": "Bỏ qua",
  "Đăng nhập để bình luận": "Đăng nhập để bình luận",
  "Danh sách tập": "Danh sách tập",
  "Ẩn bộ lọc": "Ẩn bộ lọc",
  "Lọc phim": "Lọc phim",
  "Sắp xếp": "Sắp xếp",
  "Thuyết Minh": "Thuyết Minh",
  "Lồng Tiếng": "Lồng Tiếng",
  "Viễn tưởng": "Viễn tưởng",
  "Kinh dị": "Kinh dị",
  "Bí ấn": "Bí ấn",
  "Phim 18+": "Phim 18+",
  "Tâm lý": "Tâm lý",
  "Gia đình": "Gia đình",
  "Hồng Kông": "Hồng Kông",
  "Pháp": "Pháp",
  "Đức": "Đức",
  "Hà Lan": "Hà Lan",
  "Mexico": "Mexico",
  "Thụy điển": "Thụy điển",
  "Philippines": "Philippines",
  "Châu Phi": "Châu Phi",
  "Đài Loan": "Đài Loan",
  "Năm ↓": "Năm ↓",
  "Thời gian cập nhật": "Thời gian cập nhật",
  "Vui lòng đăng nhập để sử dụng chức năng này": "Vui lòng đăng nhập để sử dụng chức năng này",
  "Tài khoản của bạn đã hết hạn đăng nhập": "Tài khoản của bạn đã hết hạn đăng nhập",
  "Click để xem phim": "Click để xem phim",
  "Tập trước": "Tập trước",
  "Tập tiếp": "Tập tiếp",
  "Xem trailer chính thức": "Xem trailer chính thức",
  "Chiếu rạp": "Chiếu rạp",

  "PHIM HOẠT HÌNH": "PHIM HOẠT HÌNH",
  "Khám phá ngay": "Khám phá ngay",
  "Từ khóa nổi bật:": "Từ khóa nổi bật:",
  "Nguồn phim được tổng hợp tự động từ các website lớn với đa dạng thể loại và quốc gia, cập nhật liên tục 24/7.": "Nguồn phim được tổng hợp tự động từ các website lớn với đa dạng thể loại và quốc gia, cập nhật liên tục 24/7.",
  "Kết nối với chúng tôi": "Kết nối với chúng tôi",
  "Hỗ trợ":"Hỗ trợ",
  "Chính sách riêng tư":"Chính sách riêng tư",
  "FAQ":"FAQ",
  "Tải ứng dụng":"Tải ứng dụng",
  'Chi tiết': 'Chi tiết',
  'Tìm phim...': 'Tìm phim...',
  'Bạn chưa lưu phim nào':'Bạn chưa lưu phim nào',
  'Hãy khám phá và thêm phim vào danh sách yêu thích':'Hãy khám phá và thêm phim vào danh sách yêu thích',
  'Khám phá phim':'Khám phá phim',
  'SÔI NỔI NHẤT':'SÔI NỔI NHẤT',
  'YÊU THÍCH NHẤT':'YÊU THÍCH NHẤT',
  'THỂ LOẠI HOT':'THỂ LOẠI HOT',
  'BÌNH LUẬN MỚI':'BÌNH LUẬN MỚI',
  'LỊCH CHIẾU PHIM':'LỊCH CHIẾU PHIM',
  'PHIM CHIẾU SỚM':'PHIM CHIẾU SỚM',
  'Không có phim chiếu sớm':'Không có phim chiếu sớm',
  'phim': 'phim',
  'Giới thiệu về':'Giới thiệu về',
  'Nền tảng xem phim trực tuyến hàng đầu dành cho người yêu điện ảnh.':'Nền tảng xem phim trực tuyến hàng đầu dành cho người yêu điện ảnh.',
  'Sứ mệnh của chúng tôi':'Sứ mệnh của chúng tôi',
  'ra đời với mong muốn mang đến cho khán giả một không gian giải trí đỉnh cao, nơi bạn có thể thưởng thức những tác phẩm điện ảnh xuất sắc nhất từ khắp nơi trên thế giới. Chúng tôi không ngừng nỗ lực cập nhật các bộ phim bom tấn, phim truyền hình đặc sắc với chất lượng hình ảnh sắc nét và âm thanh sống động nhất.':'ra đời với mong muốn mang đến cho khán giả một không gian giải trí đỉnh cao, nơi bạn có thể thưởng thức những tác phẩm điện ảnh xuất sắc nhất từ khắp nơi trên thế giới. Chúng tôi không ngừng nỗ lực cập nhật các bộ phim bom tấn, phim truyền hình đặc sắc với chất lượng hình ảnh sắc nét và âm thanh sống động nhất.',
  'Điểm nổi bật của Zcines':'Điểm nổi bật của Zcines',
  'Kho phim khổng lồ':'Kho phim khổng lồ',
  'Hàng ngàn bộ phim đa dạng thể loại từ hành động, tình cảm, hài hước đến kinh dị, viễn tưởng.':'Hàng ngàn bộ phim đa dạng thể loại từ hành động, tình cảm, hài hước đến kinh dị, viễn tưởng.',
  'Chất lượng Full HD & 4K': 'Chất lượng Full HD & 4K',
  'Trải nghiệm xem phim mượt mà không giật lag nhờ hệ thống máy chủ mạnh mẽ và tối ưu.':'Trải nghiệm xem phim mượt mà không giật lag nhờ hệ thống máy chủ mạnh mẽ và tối ưu.',
  'Cập nhật nhanh chóng':'Cập nhật nhanh chóng',
  'Các tập phim mới được đồng bộ liên tục 24/7 ngay sau khi được phát hành chính thức.':'Các tập phim mới được đồng bộ liên tục 24/7 ngay sau khi được phát hành chính thức.',
  'Liên hệ & Hỗ trợ':'Liên hệ & Hỗ trợ',
  'Danh sách yêu thích':'Danh sách yêu thích',
  'Zcines luôn luôn lắng nghe mọi ý kiến để cải thiện và mang lại trải nghiệm tuyệt vời nhất cho bạn.':'Zcines luôn luôn lắng nghe mọi ý kiến để cải thiện và mang lại trải nghiệm tuyệt vời nhất cho bạn.',
  'Khám phá phim ngay':'Khám phá phim ngay',
  'Miền Tây':'Miền Tây',
  'Trẻ Em':'Trẻ Em',
  'Lịch Sử': 'Lịch Sử',
  'Tài Liệu': 'Tài Liệu',
  'Thể Thao': 'Thể Thao',
  'Phiêu Lưu': 'Phiêu Lưu',
  'Âm Nhạc': 'Âm Nhạc',
  'Hình Sự': 'Hình Sự',
  'Võ Thuật': 'Võ Thuật',
  'Khoa Học': 'Khoa Học',
  'Thần Thoại': 'Thần Thoại',
  'Kinh Điển':'Kinh Điển',
  'Phim Ngắn': 'Phim Ngắn',
  'Ủng hộ': 'Ủng hộ',
  'Ủng hộ chúng tôi': 'Ủng hộ chúng tôi',
  'Zcines hoàn toàn miễn phí và sẽ luôn như vậy. Mỗi đóng góp của bạn giúp chúng tôi duy trì máy chủ, băng thông và tiếp tục cập nhật phim mỗi ngày.':'Zcines hoàn toàn miễn phí và sẽ luôn như vậy. Mỗi đóng góp của bạn giúp chúng tôi duy trì máy chủ, băng thông và tiếp tục cập nhật phim mỗi ngày.',
  'Vì sao cần sự ủng hộ của bạn?':'Vì sao cần sự ủng hộ của bạn?',
  'Chi phí vận hành một website xem phim không hề nhỏ: máy chủ, băng thông, subtitle và thời gian của đội ngũ. Quảng cáo chỉ đủ trang trải một phần. Với một ly cà phê từ bạn, chúng tôi có thể tiếp tục mang đến những bộ phim hay nhất hoàn toàn miễn phí cho mọi người.':'Chi phí vận hành một website xem phim không hề nhỏ: máy chủ, băng thông, subtitle và thời gian của đội ngũ. Quảng cáo chỉ đủ trang trải một phần. Với một ly cà phê từ bạn, chúng tôi có thể tiếp tục mang đến những bộ phim hay nhất hoàn toàn miễn phí cho mọi người.',
  'Hình thức ủng hộ':'Hình thức ủng hộ',
  'Sao chép':'Sao chép',
  'Nội dung chuyển khoản: UNG HO ZCINES. Sau khi chuyển khoản, bạn có thể gửi ảnh chụp biên lai qua Telegram để được xác nhận và cảm ơn.':'Nội dung chuyển khoản: UNG HO ZCINES. Sau khi chuyển khoản, bạn có thể gửi ảnh chụp biên lai qua Telegram để được xác nhận và cảm ơn.',
  'Lời cảm ơn từ Zcines':'Lời cảm ơn từ Zcines',
  'Cảm ơn bạn đã đồng hành cùng Zcines. Sự ủng hộ của bạn - dù lớn hay nhỏ - đều là động lực to lớn để chúng tôi tiếp tục phát triển và mang phim hay đến cho cộng đồng.':'Cảm ơn bạn đã đồng hành cùng Zcines. Sự ủng hộ của bạn - dù lớn hay nhỏ - đều là động lực to lớn để chúng tôi tiếp tục phát triển và mang phim hay đến cho cộng đồng.',
  'Gửi biên lai qua Telegram':'Gửi biên lai qua Telegram',
  'Đã sao chép':'Đã sao chép',
  'Không thể sao chép tự động, vui lòng sao chép thủ công':'Không thể sao chép tự động, vui lòng sao chép thủ công',


  
}
